import { render } from "./KADL.vue?vue&type=template&id=3440b0fe"
import script from "./KADL.vue?vue&type=script&lang=js"
export * from "./KADL.vue?vue&type=script&lang=js"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__